import { GameConfigSchema } from "slotworks/config/game-config-schema";
import { SymbolConfig } from "slotworks/config/game-config-schema";
import SymbolDefinition from "slotworks/model/symbol-definition";
import Point from "slotworks/utils/geom/point";
import { parseJSONMap } from "slotworks/utils/json-utils";

class SlotDefinition {

    public minLines: number = 1;
    public maxLines: number;
    public lineDefinitions: Point[][];

    public stakes: number[];
    public coinSizes: number[];

    public reelsets: Map<string, string[][]>;

    public matrixGrid: number[];

    public symbolDefinitions: SymbolDefinition[];

    public bestSymbol: SymbolDefinition;

    private highestSymbolPayout: number = 0;

    public processConfig(gameConfig: GameConfigSchema) {

        this.processStakes(gameConfig.stakeValues);
        this.processCoinSizes(gameConfig.coinSizes);
        this.processLines(gameConfig.lines);

        this.processMatrixGrid(gameConfig.matrixGrid);

        this.processSymbols(gameConfig.symbols);
        this.processReelSets(gameConfig.reelsets);
    }

    public getSymbolDefinition(id: string): SymbolDefinition {
        for (const symbol of this.symbolDefinitions) {
            if (symbol.id === id) {
                return symbol;
            }
        }
        throw new Error("Symbol in aperture response which isn't found in symbolDefinitions: " + id);
    }

    public isSingleBetLevel() {
        return this.stakes.length === 1;
    }

    private processStakes(stakes: number[]) {
        this.stakes = stakes;
    }

    private processCoinSizes(coinSizes: number[]) {
        this.coinSizes = coinSizes;
    }

    private processLines(lines: number[][]) {
        this.lineDefinitions = [];

        for (const line of lines) {

            const lineDefinition = [];
            let x = 0;

            for (const position of line) {
                lineDefinition.push(new Point(x, position));
                x++;
            }

            this.lineDefinitions.push(lineDefinition);
        }

        this.maxLines = this.lineDefinitions.length;
    }

    private processReelSets(reelsets: { [id: string]: number[][] }) {
        this.reelsets = new Map<string, string[][]>();

        for (const reelsetId in reelsets) {

            if (reelsets.hasOwnProperty(reelsetId)) {
                const reelset = reelsets[reelsetId];

                const parsedReelset = [];

                for (const reel of reelset) {

                    const parsedReel: string[] = [];
                    parsedReelset.push(parsedReel);

                    for (const symbolId of reel) {
                        parsedReel.push(this.symbolDefinitions[symbolId].id);
                    }
                }

                this.reelsets.set(reelsetId, parsedReelset);
            }
        }
    }

    private processMatrixGrid(matrixGrid: number[]) {
        this.matrixGrid = matrixGrid;
    }

    private processSymbols(symbols: SymbolConfig[]) {
        this.symbolDefinitions = [];

        for (const symbol of symbols) {
            const symbolDef = symbol as SymbolDefinition;
            symbolDef.name = symbol.name || symbol.id;
            if (symbol.payouts) {
                symbolDef.payouts = parseJSONMap<number>(symbol.payouts);
            }
            if (!symbol.size) {
                symbol.size = 1;
            }

            this.symbolDefinitions.push(symbolDef);

            // Helpfully keep a reference to the highest paying symbol
            if (symbolDef.payouts) {
                symbolDef.payouts.forEach((value: number) => {
                    if (value > this.highestSymbolPayout) {
                        this.highestSymbolPayout = value;
                        this.bestSymbol = symbolDef;
                    }
                });
            }
        }
    }
}

export default new SlotDefinition();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/model/slot-definition.ts